import useInitialConfigStore from "../../../storeModules/useInitialConfigStore";
import { tipoPlanoNomeCased } from "../../../utils/constants";
import getMycoins from "../../../utils/getMycoins";
import { getRemoteValueEnv } from "../../../setup";
import mycoinsBot from "../../../config/mycoinsBot";

export const setMycoinsInitialConfig = (selectedPlano) => {
  const isMycoins = !!getMycoins();

  const firebaseMycoins = JSON.parse(
    getRemoteValueEnv("mycoins_dev", "mycoins_prod").asString()
  );

  if (!isMycoins) return;

  if (selectedPlano.nome === tipoPlanoNomeCased.CREDITO_PAGAMETADE) {
    useInitialConfigStore.setState({
      empresaId:
        firebaseMycoins.empresaId_pagametade ??
        mycoinsBot[0].empresaId_pagametade,
      compraId:
        firebaseMycoins.compraId_pagametade ??
        mycoinsBot[0].compraId_pagametade,
    });
  }

  if (selectedPlano.nome === tipoPlanoNomeCased.CREDITO_INTEGRAL) {
    useInitialConfigStore.setState({
      empresaId: firebaseMycoins.empresaId ?? mycoinsBot[0].empresaId,
      compraId: firebaseMycoins.compraId ?? mycoinsBot[0].compraId,
    });
  }

  if (selectedPlano.nome === tipoPlanoNomeCased.PAGA_REDUZIDA) {
    useInitialConfigStore.setState({
      empresaId:
        firebaseMycoins.empresaId_reduzida ??
        mycoinsBot[0].empresaId_reduzida,
      compraId:
        firebaseMycoins.compraId_reduzida ?? mycoinsBot[0].compraId_reduzida,
    });
  }
};
